import { render, staticRenderFns } from "./OrgInviteList.vue?vue&type=template&id=2dde5472"
import script from "./OrgInviteList.vue?vue&type=script&lang=js"
export * from "./OrgInviteList.vue?vue&type=script&lang=js"
import style0 from "./OrgInviteList.vue?vue&type=style&index=0&id=2dde5472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports